import { Link } from 'react-router-dom';
import { BUSINESS } from '@/lib/constants';
import { ArrowUpRight } from 'lucide-react';

const FOOTER_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Associate Network', path: '/associate-network' },
  { label: 'Contact', path: '/contact' },
];

const EVENT_LINK = 'https://linktr.ee/theconnectionstrategist?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnVMEwnjfbNw4sQOhB1BfY_7F3JrSWYmL65ruc-Kiywx5Eb_lIjzp_vNATPNA_aem_0TpLAo0FCXpv-404zbFcmQ';
const IT_LINK = 'https://solacium.us/';

const SERVICE_LINKS = [
  { label: 'Bookkeeping', path: '/services', external: false },
  { label: 'Vintage Wine & Champagne', path: '/wine', external: false },
  { label: 'Web Design', path: '/web-design', external: false },
  { label: 'Events & Vendor Connections', path: EVENT_LINK, external: true },
  { label: 'IT & Programming', path: IT_LINK, external: true },
];

export default function Footer() {
  return (
    <footer className="bg-wc-black text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="mb-6">
              <span className="font-accent text-xs uppercase tracking-[0.2em] text-white font-semibold block">
                William Covington
              </span>
              <span className="font-accent text-[10px] uppercase tracking-[0.2em] text-white/50">
                & Associates
              </span>
            </div>
            <p className="font-body text-sm text-white/50 leading-relaxed">
              Premier bookkeeping and financial organization for small businesses and entrepreneurs.
            </p>
          </div>

          <div>
            <h4 className="font-accent text-xs uppercase tracking-[0.2em] text-wc-gold mb-6">Navigate</h4>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((link) => (
                <li key={link.path + link.label}>
                  <Link
                    to={link.path}
                    className="font-body text-sm text-white/60 hover:text-white transition-colors duration-300"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-accent text-xs uppercase tracking-[0.2em] text-wc-gold mb-6">Services</h4>
            <ul className="space-y-3">
              {SERVICE_LINKS.map((link) => (
                <li key={link.label}>
                  {link.external ? (
                    <a
                      href={link.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-body text-sm text-white/60 hover:text-white transition-colors duration-300 flex items-center gap-1"
                    >
                      {link.label}
                      <ArrowUpRight className="w-3 h-3 opacity-40" strokeWidth={1.5} />
                    </a>
                  ) : (
                    <Link
                      to={link.path}
                      className="font-body text-sm text-white/60 hover:text-white transition-colors duration-300"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-accent text-xs uppercase tracking-[0.2em] text-wc-gold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="font-body text-sm text-white/60">{BUSINESS.address}</li>
              <li>
                <a href={`tel:${BUSINESS.phone}`} className="font-body text-sm text-white/60 hover:text-white transition-colors duration-300">
                  {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${BUSINESS.email}`} className="font-body text-sm text-white/60 hover:text-white transition-colors duration-300 break-all">
                  {BUSINESS.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/40">
            &copy; {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.
          </p>
          <a
            href={`https://${BUSINESS.website}`}
            target="_blank"
            rel="noopener noreferrer"
            className="font-body text-xs text-white/40 hover:text-white/60 transition-colors duration-300 flex items-center gap-1"
          >
            {BUSINESS.website} <ArrowUpRight className="w-3 h-3" strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </footer>
  );
}
